/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Rate_EmbedInputs */



/**
* | output |
* | --- |
* | "$2.00 / job" |
*
* @param {Usage_Rate_EmbedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_rate_embed = /** @type {((inputs?: Usage_Rate_EmbedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Rate_EmbedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("2,00 $ / emploi")
	if (locale === "de") return /** @type {LocalizedString} */ ("2,00 € / Auftrag")
	if (locale === "it") return /** @type {LocalizedString} */ ("$2,00 / lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("2,00 доллара за работу")
	if (locale === "es") return /** @type {LocalizedString} */ ("$2.00 / trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每份工作 2.00 美元")
	if (locale === "ja") return /** @type {LocalizedString} */ ("2.00ドル/仕事")
	if (locale === "hi") return /** @type {LocalizedString} */ ("$2.00 प्रति कार्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("US$ 2,00 por serviço")
	return /** @type {LocalizedString} */ ("$2.00 / job")
});